export const EditMenuIcon = ({
  strokeColor = "var(--color-icon-obscure)",
  ...props
}: any) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M8 2.00006H3.33333C2.97971 2.00006 2.64057 2.14054 2.39052 2.39059C2.14048 2.64064 2 2.97977 2 3.3334V12.6667C2 13.0204 2.14048 13.3595 2.39052 13.6095C2.64057 13.8596 2.97971 14.0001 3.33333 14.0001H12.6667C13.0203 14.0001 13.3594 13.8596 13.6095 13.6095C13.8595 13.3595 14 13.0204 14 12.6667V8.00006M12.2501 1.75021C12.5153 1.485 12.875 1.336 13.2501 1.336C13.6251 1.336 13.9848 1.485 14.2501 1.75021C14.5153 2.01543 14.6643 2.37514 14.6643 2.75021C14.6643 3.12529 14.5153 3.485 14.2501 3.75021L8.2414 9.75955C8.0831 9.91771 7.88753 10.0335 7.67273 10.0962L5.7574 10.6562C5.70003 10.6729 5.63922 10.6739 5.58134 10.6591C5.52345 10.6443 5.47061 10.6142 5.42836 10.5719C5.38611 10.5297 5.35599 10.4768 5.34116 10.4189C5.32633 10.3611 5.32733 10.3002 5.34406 10.2429L5.90406 8.32755C5.96708 8.11291 6.08309 7.91759 6.2414 7.75955L12.2501 1.75021Z"
      stroke={strokeColor}
      strokeLinecap="round"
    />
  </svg>
);
